import { IFetchCustomerScheduledSessionsDTO } from 'modules/customer/domain/dtos';
import { ISchedulesRepository } from 'shared/domain/repositories';

export class FetchCustomerScheduledSessionsUseCase {
  constructor(private schedulesRepository: ISchedulesRepository) {}

  public async execute({ customerId }: IFetchCustomerScheduledSessionsDTO) {
    return this.schedulesRepository.findAll({
      customerId,
      filter: 'NEXT',
    });
  }
}
